import { MuiTheme, createStyles, makeStyles, color } from '@kis-technologies/kis-ui';

export const useStyles = (props?: { showOverlay: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      kioskDetailsOuterBox: {
        flex: 1,
        minHeight: 0,
        background: 'transparent',
        padding: '0px 40px',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 20px 20px'
        }
      },
      kioskDetailsHeaders: {
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600,
        cursor: 'pointer'
      },
      kioskDetailsKioskName: {
        paddingLeft: '24px',
        color: 'inherit'
      },
      kioskDetailsCell: {
        color: 'inherit'
      },
      Active: {
        color: '#2A2A2A'
      },
      Inactive: {
        color: '#C40B0F'
      },
      kioskDetailsNameInactive: {
        color: '#C40B0F',
        paddingLeft: '24px !important'
      },
      saveButtonBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.only('xs')]: {
          margin: '32px 0px'
        }
      },
      ReloadDataButton: {
        '& > *': {
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex'
        },
        '& > * > * ': {
          height: '50px',
          width: '60%'
        },
        '& > * > * > input': {
          minWidth: 'auto'
        }
      },
      kioskRestockBox: {
        background: 'transparent',
        minWidth: '100%',
        height: '100px',
        [theme.breakpoints.down('xs')]: {
          height: '110px'
        },
        '& > * > *': {
          [theme.breakpoints.down('xs')]: {
            minWidth: '240px',
            width: '245px'
          }
        }
      },
      kisokRestockInnerBox: {
        background: 'transparent',
        minWidth: '100%',
        height: '100px',
        [theme.breakpoints.down('xs')]: {
          height: '110px'
        },
        '& > * > *': {
          [theme.breakpoints.down('xs')]: {
            minWidth: '240px',
            width: '245px'
          }
        }
      },
      restockPrinterLabel: {
        paddingLeft: '16px',
        margin: '0px 0px 10px',
        fontSize: '16px',
        fontWeight: 'bold'
      },
      saveButton: {
        width: '200px',
        [theme.breakpoints.only('xs')]: {
          width: '150px'
        }
      },
      kiosksHeaderBlock: {
        justifyContent: 'space-between',
        background: 'transparent',
        padding: '24px 40px',
        display: 'flex',
        height: '100px',
        alignItems: 'center',
        [theme.breakpoints.down('lg')]: {
          height: 'auto',
          flexDirection: 'column',
          gap: '20px',
          alignItems: 'baseline'
        },
        [theme.breakpoints.only('sm')]: {
          alignItems: 'flex-start'
        },
        [theme.breakpoints.down('sm')]: {
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '18px 20px 18px 20px',
          flexDirection: 'row'
        },
        [theme.breakpoints.only('xs')]: {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }
      },
      kiosksHeading: {
        fontSize: '40px',
        fontWeight: 600,
        lineHeight: '1',
        [theme.breakpoints.only('xs')]: {
          fontSize: '32px'
        }
      },
      kioskStatusHeading: {
        fontSize: '24px',
        lineHeight: 'inherit',
        letterSpacing: 'normal',
        margin: '0px',
        [theme.breakpoints.down('xs')]: {
          fontSize: '20px'
        }
      },
      kioskButtonWrap: {
        display: 'flex',
        justifyContent: 'end',
        padding: '0 40px 24px 40px',
        [theme.breakpoints.down('md')]: {
          gap: '10px'
        }
      },
      tabButtonsWrap: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          gap: '10px',
          alignItems: 'baseline',
          marginBottom: '5px'
        },
        [theme.breakpoints.only('xs')]: {
          alignItems: 'center'
        }
      },
      switchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      },
      switchLabel: {
        fontSize: '18px',
        lineHeight: 'inherit',
        letterSpacing: 'normal',
        padding: '8px',
        fontWeight: 600,
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
          fontSize: '20px'
        }
      },
      kioskRestockHeading: {
        fontSize: '32px',
        lineHeight: 'inherit',
        letterSpacing: 'normal',
        margin: '0px',
        [theme.breakpoints.down('xs')]: {
          fontSize: '20px'
        }
      },
      statusOverlayTableBox: {
        flex: '1',
        background: 'transparent',
        paddingBottom: '16px',
        '& > * > * > * > *': {
          [theme.breakpoints.down('xs')]: {
            whiteSpace: 'normal'
          }
        }
      },
      kioskHardwareHeaderType: {
        paddingLeft: '24px',
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600
      },
      kioskHardwareHeaders: {
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600
      },
      kioskHardwareTableRows: {
        height: '70px'
      },
      kioskHardwareType: {
        paddingLeft: '24px'
      },
      KioskActionsButtons: {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        '& > img': {
          cursor: 'pointer'
        }
      },
      kioskStatusRow: {
        display: 'flex',
        alignItems: 'center'
      },
      activeStatusButton: {
        color: color.BLACK,
        background: 'white',
        border: 'white',
        height: '35px',
        width: '110px',
        whiteSpace: 'nowrap',
        '&:hover': {
          background: 'white',
          border: 'white'
        },
        '& > * > * > *': {
          fill: `${color.GREEN} !important`
        }
      },
      inactiveStatusButton: {
        color: color.RED,
        background: 'white',
        border: 'white',
        height: '35px',
        width: '110px',
        whiteSpace: 'nowrap',
        '&:hover': {
          background: 'white',
          border: 'white'
        },
        '& > * > * > *': {
          fill: `${color.RED} !important`
        }
      },
      offlineStatusBox: {
        width: '110px',
        textAlign: 'center',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center'
      },
      kioskDetailsOverlay: {
        width: '616px',
        background: 'white',
        color: '#2A2A2A',
        [theme.breakpoints.down('sm')]: {
          width: 'auto'
        },
        [theme.breakpoints.only('xs')]: {
          width: '365px',
          padding: '10px 0px 32px 0px'
        }
      },
      kioskRestockDetailsOverlay: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column'
      },
      kioskOverlayHeaderBlock: {
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        padding: '24px 24px 24px 24px',
        gap: '10px',
        [theme.breakpoints.only('xs')]: {
          alignItems: 'flex-start',
          flexDirection: 'column-reverse',
          padding: '8px'
        }
      },
      kioskOverlayHeading: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          paddingTop: '10px',
          paddingLeft: '20px'
        }
      },
      footer: {
        width: '100%',
        overflow: 'hidden',
        padding: '0px 40px'
      },
      total: {
        float: 'right',
        fontSize: '20px',
        padding: '24px 0 0',
        margin: 0,
        fontWeight: 900
      },
      kioskOverlayCloseIcon: {
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'flex-end',
          width: '100%'
        },
        '& > * > *': {
          [theme.breakpoints.only('xs')]: {
            width: '30px'
          }
        }
      },
      popupOverlay: {
        position: 'fixed',
        top: '0',
        left: '38%',
        width: '30%',
        height: '85%',
        // backgroundColor: 'rgba(0, 0, 0, 0.5)', /* Semi-transparent background overlay */
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      },
      popup: {
        backgroundColor: 'ghostWhite',
        padding: '20px 10px',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
          width: 'auto'
        },
        [theme.breakpoints.only('xs')]: {
          height: '25%'
        },
        borderRadius: '40px',
        boxShadow: '9px 7px 6px rgba(0, 0, 0, 0.2)',
        border: '1px solid grey'
      },
      popupContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: '25px',
        fontWeight: 700,
        margin: '35px 0px'
      },
      message: {
        marginBottom: '50px'
      },
      closeButton: {
        padding: '10px 20px',
        borderRadius: '4px',
        backgroundColor: '#f46d2e',
        border: 'none',
        cursor: 'pointer'
      },
      kioskStatusBox: {
        background: 'transparent',
        minWidth: '100%',
        height: '100px',
        [theme.breakpoints.down('xs')]: {
          height: '110px'
        },
        '& > * > *': {
          [theme.breakpoints.down('xs')]: {
            minWidth: '240px',
            width: '245px'
          }
        }
      },
      kioskStatusLabel: {
        paddingLeft: '16px',
        margin: '0px 0px 10px',
        fontSize: '16px',
        fontWeight: 'bold'
      },
      formInnerContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: 'transparent'
      },
      formInputBox: {
        background: 'transparent',
        height: '120px',
        minWidth: '100%',
        display: 'flex',
        gap: '1rem',
        [theme.breakpoints.down('xs')]: {
          height: '110px'
        },
        '& > * > * > input': {
          [theme.breakpoints.down('xs')]: {
            height: '40px'
          }
        }
      },
      formDropdownLabel: {
        margin: '0px 0px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        paddingLeft: '16px'
      },
      body: {
        overflow: props && props.showOverlay ? 'hidden' : 'auto'
      },
      restockOverlayFieldBox: {
        height: '110px'
      },
      statusOverlaySwitchBox: {
        alignItems: 'center',
        padding: '0 0 16px'
      }
    })
  );
